export function isAcademicPlanFeatureRestricted(isAcademic?: boolean, isAuthenticated?: boolean): boolean {
  return Boolean(isAcademic && isAuthenticated);
}
